import api from '../../utils/api';
import {
    CREATE_NEW_CUSTOMER_DATA
} from './types';
import { NotificationManager } from 'react-notifications';

export const createCustomer = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/customer-data', data).then(res => {
            dispatch({ type: CREATE_NEW_CUSTOMER_DATA, payload: res.data.data });
            NotificationManager.success(res.data.msg);
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        })
    })
}